export const styleByScreenSize = (isMobile) => {
  if (isMobile) {
    return {
      width: '100%',
      height: '100%',
      borderRadius: 0,
    }
  }
  return {
    width: 'calc(100% - 20px)',
    height: 'calc(100% - 20px)',
    margin: '10px',
  }
}
